import { useField } from 'formik'
import { BrandPlanTactic, ContentCount as CountCountType } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import { Checkbox } from 'components/CheckboxGroup/Checkbox'
import Styles from './CrosspostTactics.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { useMemo } from 'react'

export const StoriesTactics = ({ name }: { name: string }) => {
  const [field] = useField<[CountCountType]>(name)
  const storiesIndex = field.value.findIndex((value) => value.type === 'story')
  const [storiesField] = useField<CountCountType>(`${name}.${storiesIndex}`)

  const value = useMemo(() => {
    const value: BrandPlanTactic[] = []

    if (storiesField.value.count > 0) {
      value.push(BrandPlanTactic.Instagram)
    }
    return value
  }, [storiesField.value.count])

  return (
    <CheckboxGroup value={value} onChange={() => {}} className={Styles.group} label="Stories">
      <Checkbox
        value={BrandPlanTactic.Instagram}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.Instagram}
        className={Styles.checkbox}
      >
        <div className={Styles.checkboxLabel}>
          <InstagramBrand size={20} />
          <Text variant="largeList" color="var(--dark-80)">
            Instagram
          </Text>
        </div>
      </Checkbox>
    </CheckboxGroup>
  )
}
